import options from './options'
import inputs from './inputs'

export default {
    mixins: [inputs, options],
}
